import { NavBar } from "./NavBar";
import { Footer } from "./Footer";
import { PortfolioContentFive } from "./projectFive/PortfolioContentFive";

export const PortfolioCotta = () => {
  return (
    <div>
      <NavBar />
      <PortfolioContentFive />
      <Footer />
    </div>
  );
};
